import clsx from 'clsx'
import React, {useState} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {DateRangeProvider} from '@/components/context/DateRangeContext'
import PaymentReportPane from './components/panes/PaymentReportPane'
import EarningsReportPane from './components/panes/EarningsReportPane'
import OrderReportPane from './components/panes/OrderReportPane'
import CustomerReportPane from './components/panes/CustomerReportPane'
import OverviewReportPane from './components/panes/OverviewReportPane'

type TabProps = {
  key: string
  label: string
}

const tabs : TabProps[] = [{
  key: 'overview', 'label': 'Overview',
}, {
  key: 'customer', 'label': 'Customers',
}, {
  key: 'payment', 'label': 'Payment',
}, {
  key: 'order', 'label': 'Orders',
}, {
  key: 'earnings', 'label': 'Earnings',
}]

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}])

const DashboardPage = () => {
  const [tab, setTab] = useState<string>('overview')

  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>Passtocard</PageTitle>
      <DateRangeProvider
        defaultRange="month"
        minDate={new Date('2012-01-01')}
        maxDate={new Date()}
        middleContent={
          <ul className="pagination">
            {tabs.map((t: TabProps) => (
              <li className="page-item" key={`report-tab-${t.key}`}>
                <button
                  className={clsx('btn btn-sm btn-active btn-active-primary me-3', {
                    'btn-primary active': t.key === tab,
                    'btn-secondary ': t.key !== tab
                  })}
                  onClick={()=> setTab(t.key)}
                  disabled={t.key === tab}
                >
                  {t.label}
                </button>
              </li>
            ))}
          </ul>
        }
      >
        {tab === 'payment' ? (
          <PaymentReportPane />
        ) : tab === 'order' ? (
          <OrderReportPane />
        ) : tab === 'earnings' ? (
          <EarningsReportPane />
        ) : tab === 'overview' ? (
          <OverviewReportPane />
        ) : (
          <CustomerReportPane />
        )}
      </DateRangeProvider>
    </>
  )
}

export default DashboardPage
